"use strict";
if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (search, thisLen) {
        if (thisLen === undefined || thisLen > this.length) {
            thisLen = this.length;
        }
        return this.substring(thisLen - search.length, thisLen) === search;
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/_react-dnd@7.4.5@react-dnd/lib/cjs/utils/polyfills/endsWith.js
// module id = 271
// module chunks = 0